// extracted by mini-css-extract-plugin
export var actions = "_m4-d";
export var benefitCard = "_m4-a";
export var benefitIcon = "_m4-b";
export var benefitLabel = "_m4-c";
export var benefits = "_m4-9";
export var bodyText = "_m4-8";
export var closeButton = "_m4-2";
export var content = "_m4-3";
export var eyebrow = "_m4-4";
export var heading = "_m4-5";
export var image = "_m4-f";
export var imagePanel = "_m4-e";
export var modal = "_m4-0";
export var shell = "_m4-1";
export var title = "_m4-6";
export var titleOffer = "_m4-7";